exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yxtbiz-watermark-v2[data-v-0c478b46]{position:absolute;width:100%;height:100%;top:0;left:0;z-index:9999;pointer-events:none}\n", ""]);

